module.exports = __webpack_public_path__ + "img/G001_R_home slider.f1ee4616.jpg";